// extracted by mini-css-extract-plugin
export var ArticleCard = "ArticleCardVerticalBlock-module--ArticleCard--d4173";
export var articleContent = "ArticleCardVerticalBlock-module--articleContent--e0929";
export var buttonTag = "ArticleCardVerticalBlock-module--buttonTag--c3030";
export var capitalize = "ArticleCardVerticalBlock-module--capitalize--c47ea";
export var date = "ArticleCardVerticalBlock-module--date--a68db";
export var dateMobile = "ArticleCardVerticalBlock-module--dateMobile--616c2";
export var fs14 = "ArticleCardVerticalBlock-module--fs-14--f0438";
export var fs16 = "ArticleCardVerticalBlock-module--fs-16--ce432";
export var fs20 = "ArticleCardVerticalBlock-module--fs-20--0b125";
export var fs24 = "ArticleCardVerticalBlock-module--fs-24--52637";
export var fs32 = "ArticleCardVerticalBlock-module--fs-32--5f1cf";
export var fs40 = "ArticleCardVerticalBlock-module--fs-40--c8f92";
export var fsItalic = "ArticleCardVerticalBlock-module--fs-italic--7f2fb";
export var fsLg = "ArticleCardVerticalBlock-module--fs-lg--a6e10";
export var fsMd = "ArticleCardVerticalBlock-module--fs-md--4bcfd";
export var fsNormal = "ArticleCardVerticalBlock-module--fs-normal--498db";
export var fsSm = "ArticleCardVerticalBlock-module--fs-sm--8080a";
export var fsXl = "ArticleCardVerticalBlock-module--fs-xl--b63ac";
export var fsXs = "ArticleCardVerticalBlock-module--fs-xs--8b085";
export var fsXxl = "ArticleCardVerticalBlock-module--fs-xxl--826c1";
export var fsXxs = "ArticleCardVerticalBlock-module--fs-xxs--c80e7";
export var fwBold = "ArticleCardVerticalBlock-module--fw-bold--fd215";
export var fwMedium = "ArticleCardVerticalBlock-module--fw-medium--50d58";
export var fwNormal = "ArticleCardVerticalBlock-module--fw-normal--2fde5";
export var gotham_bold = "ArticleCardVerticalBlock-module--gotham_bold--50cec";
export var gotham_bold_italic = "ArticleCardVerticalBlock-module--gotham_bold_italic--0cbeb";
export var gotham_book = "ArticleCardVerticalBlock-module--gotham_book--f0bc6";
export var gotham_book_italic = "ArticleCardVerticalBlock-module--gotham_book_italic--b9412";
export var icon = "ArticleCardVerticalBlock-module--icon--ebefc";
export var iconContainer = "ArticleCardVerticalBlock-module--iconContainer--0a1f8";
export var img = "ArticleCardVerticalBlock-module--img--e0123";
export var lowercase = "ArticleCardVerticalBlock-module--lowercase--d7eb2";
export var seeMoreButton = "ArticleCardVerticalBlock-module--seeMoreButton--24c25";
export var tag = "ArticleCardVerticalBlock-module--tag--c8b3b";
export var tagMobile = "ArticleCardVerticalBlock-module--tagMobile--1cfac";
export var tagsContainer = "ArticleCardVerticalBlock-module--tagsContainer--a9225";
export var tagsMobile = "ArticleCardVerticalBlock-module--tagsMobile--4e17e";
export var tagsSwiper = "ArticleCardVerticalBlock-module--tagsSwiper--6bc94";
export var uppercase = "ArticleCardVerticalBlock-module--uppercase--058df";